import React, { useEffect, useState } from "react";
import teamIcon from "../assets/icons/mangment icons/team.png";

import {
  deleteDataToken,
  getData,
  patchDataToken,
  postData,
  putDataToken,
} from "../axios/axiosHelper";
import toast from "react-hot-toast";
import { ADMIN_PAGE_LABELS } from "../navigation/adminNavigation";

const PaymentMethodHook = () => {
  const [imageForEdit, setImageForEdit] = useState(false)

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [paymentMethodEn, setPaymentMethodEn] = useState(null);
  const [paymentMethodAr, setPaymentMethodAr] = useState(null);
  const [loadingAddPaymentMethod, setLoadingAddPaymentMethod] = useState(false);
  const [allPaymentMethod, setAllPaymentMethod] = useState([]);
  const [deletePaymentMethodLoading, setDeletePaymentMethodLoading] = useState({});
  const [showEditPaymentMethod, setShowEditPaymentMethod] = useState(false);
  const [loadingEditPaymentMethod, setLoadingEditPaymentMethod] = useState(false);
  const handleCloseEditPaymentMethod = () => setShowEditPaymentMethod(false);
  const handleShowEditPaymentMethod = () => setShowEditPaymentMethod(true);
  const [onePaymentMethodData, setOnePaymentMethodData] = useState({});
  const [nameEnEdit, setNameEnEdit] = useState(null);
  const [nameArEdit, setNameArEdit] = useState(null);
  const [image, setImage] = useState(null);

  const NavItems = [
    {
      name: ADMIN_PAGE_LABELS.merchantPaymentMethods,
      to: "/paymentMethod",
      icon: teamIcon,
    },
    
  ];
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(file);
    }
  };
  const addNewPaymentMethod = async (e) => {
    e.preventDefault();
    setLoadingAddPaymentMethod(true);
    if (!image) {
      toast.error("Please fill in all fields");
      return;
    }
    const formData = new FormData();
    formData.append("nameEn", paymentMethodEn);
    formData.append("nameAr", paymentMethodAr);

    formData.append("image", image);

    let arRegex = /^[0-9\u0600-\u06FF\s]+$/;
    if (!arRegex.test(paymentMethodAr)) {
      toast.error("Please Enter An Arabic payment Method Name Correct");
      setLoadingAddPaymentMethod(false);
    } else {
      postData(
        `/paymentMethod`,
        formData,
        true
      )
        .then((response) => {
          setPaymentMethodEn("");
          setPaymentMethodAr("");
          handleClose();
          toast.success(response?.data?.message);
          getAllPaymentMethods(currentPage, itemsPerPage, search);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        })
        .finally(() => {
          setLoadingAddPaymentMethod(false);
        });
    }
  };

  const getAllPaymentMethods = (page = 1, perPage = 10, search) => {
    setLoading(true);
    getData(`/paymentMethod?page=${page}&perPage=${perPage}&search=${search}`, true)
      .then((response) => {
        setAllPaymentMethod(response?.data?.data);
        setTotalPages(response?.data?.pagination?.totalPages || 1);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllPaymentMethods(currentPage, itemsPerPage, search);
  }, [currentPage, itemsPerPage, search]);

  const getPageNumbers = () => {
    const pages = [];
    const startPage = Math.max(1, currentPage - 1);
    const endPage = Math.min(totalPages, startPage + 2);
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const deletePaymentMethod = async (id) => {
    setDeletePaymentMethodLoading((prevState) => ({ ...prevState, [id]: true }));
    deleteDataToken(`/paymentMethod/${id}`)
      .then((response) => {
        toast.success(response?.data?.message);
        getAllPaymentMethods(currentPage, itemsPerPage, search);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setDeletePaymentMethodLoading((prevState) => ({ ...prevState, [id]: false }));
      });
  };

  const clickOnePaymentMethod = (data) => {
    setOnePaymentMethodData(data);
    setNameEnEdit(data.nameEn);
    setNameArEdit(data.nameAr);
    handleShowEditPaymentMethod();
    setImageForEdit(data.image)
  };

  const editPaymentMethod = async (e) => {
    e.preventDefault();
    setLoadingEditPaymentMethod(true);
    const formData = new FormData();
    formData.append("nameEn", nameEnEdit);
    formData.append("nameAr", nameArEdit);

    formData.append("image", image);
    let arRegex = /^[0-9\u0600-\u06FF\s]+$/;
    if (!arRegex.test(nameArEdit)) {
      toast.error("Please Enter An Arabic PaymentMethod Name Correct");
      setLoadingEditPaymentMethod(false);
    } else {
      putDataToken(
        `/paymentMethod/${onePaymentMethodData._id}`,
        formData,
        true
      )
        .then((response) => {
          setPaymentMethodEn("");
          setPaymentMethodAr("");
          handleCloseEditPaymentMethod();
          toast.success(response?.data?.message);
          getAllPaymentMethods(currentPage, itemsPerPage, search);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        })
        .finally(() => {
          setLoadingEditPaymentMethod(false);
        });
    }
  };

  return {
    NavItems,
    setSearch,
    handleShow,
    show,
    handleClose,
    addNewPaymentMethod,
    setPaymentMethodEn,
    paymentMethodEn,
    paymentMethodAr,
    setPaymentMethodAr,
    allPaymentMethod,
    handlePageChange,
    getPageNumbers,
    loadingAddPaymentMethod,
    currentPage,
    totalPages,
    deletePaymentMethod,
    deletePaymentMethodLoading,
    clickOnePaymentMethod,
    showEditPaymentMethod,
    handleCloseEditPaymentMethod,
    editPaymentMethod,
    setNameEnEdit,
    nameEnEdit,
    nameArEdit,
    setNameArEdit,
    loadingEditPaymentMethod,
    loading,
    handleImageChange,
    imageForEdit
  };
};

export default PaymentMethodHook;
